import DeleteStructureModal from "./DeleteStructureModal";
export default DeleteStructureModal;
